<template>
 <path d="M6 6L11 1M6 6L11 11M6 6L1 1M6 6L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</template>
